<style lang="less">
    @import "../../../../styles/common-table-list.less";
</style>
<template>
    <div style="min-height: 726px;height: auto;padding-bottom: 20px;" class="center-table-list">
        <div class="table-list">
            <!--      标题      -->
            <div class="table-list-title">
                <span class="myTitle" >查看详情</span>
            </div>
            <!--      服务状态水平时间轴      -->
            <div class="service_time_axis">
                <Timeline :data="TimelineData"></Timeline>
            </div>

            <!--      服务类型      -->
            <div class="service_type">服务类型：{{ serviceMsg.subBizType ? serviceMsg.subBizType : '' }}</div>

            <!--      服务进度纵向时间轴      -->
            <div class="service_content">
                <div class="name_main">
                    <div class="service_img">
                        <img src="@/assets/customer_service.png" alt='版权登记'>
                    </div>
                    <p class="service_name">服务商：{{serviceMsg.serviceMan?serviceMsg.serviceMan:'暂无'}}</p>
                </div>

                <ul class="vertical_time_line">
                    <li v-for="(item,index) in serviceContent" class="vertical_time_line_item" :key="index">
                        <div class="time_line_item_content">
                            <span class="time_line_item_content_item">{{ item.lawyerServiceTime }}</span>
                            <span class="time_line_item_content_item">{{ item.lawyerServiceLog }}</span>
                        </div>
                    </li>

                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    import Timeline from '@/views/main-components/horizontal-timeline';
    import {getOrderDetailPage} from '@/api/staticPage'

    export default {
        metaInfo: {
            title: '法律服务记录|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '法律服务订单,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "legal-order-details",
        components: {
            Timeline
        },
        data() {
            return {
                orderId:'',
                TimelineData: [], //服务状态
                serviceContent:[], //服务内容
                serviceMsg:'', //服务信息
            }
        },
        created() {
            if (this.$route.query.id && this.$route.query.id != '') {
                this.orderId = this.$route.query.id;
                this.getData();
            }
        },
        methods: {

            /*******************内容接口******************/
            getData(){
                let data = {
                    orderSeqNo:this.orderId
                };
                getOrderDetailPage(data).then(res=>{
                    if(res.code == 200){
                        let result = res.result;

                        /********************服务状态*******************/
                        let statusRecords = result.statusRecords;
                        for(let i =0; i<statusRecords.length; i++){
                            this.TimelineData.push({name: statusRecords[i].name, state: statusRecords[i].status});
                        }

                        /********************服务内容*******************/
                        this.serviceContent = result.list;

                        /********************服务信息*******************/
                        this.serviceMsg = result.order;
                    }
                    else{
                        toast(res.message);
                    }
                },(err)=>{
                    console.log(err);
                })
            },


        }
    }
</script>

<style scoped lang="less">
    ul, ol {
        list-style: none;
    }

    .service_time_axis {
        padding: 44px 0 67px;
    }

    .service_type {
        background: #FBFBFB;
        color: #333333;
        font-size: 14px;
        width: 100%;
        padding: 15px 35px;
    }

    .service_content {
        padding: 30px 35px;
        display: flex;
        color: #333;
        font-size: 14px;
        width: 100%;
        box-sizing: border-box;

        .name_main {
            padding-right: 75px;
        }

        .name_main .service_img {
            width: 68px;
            height: 68px;
            background: #E6E6E6;
            border-radius: 4px;
            margin-bottom: 10px;

            img {
                display: block;
                width: 100%;
                height: 100%;
                border-radius: 4px;
            }
        }

        .vertical_time_line {
            .vertical_time_line_item {
                padding-bottom: 28px;
                border-left: 1px dashed #979797;
                position: relative;

                .time_line_item_content {
                    padding-left: 24px;
                    position: relative;
                    top: -4px;

                    .time_line_item_content_item {
                        padding-right: 15px;
                    }
                }
            }

            .vertical_time_line_item:before {
                content: '';
                position: absolute;
                top: 0;
                left: -5px;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background: #D8D8D8;
            }

            .vertical_time_line_item:last-child {
                padding-bottom: 0;
                border-left: 0;

            }
        }
    }
</style>
